export default __webpack_public_path__ + "static/media/crowdfunding.b39d1fb8.png";